import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 2rem;
	padding: 0 1.6rem 2.4rem;

	@media (${Breakpoints.mobile}) {
		padding: 2.6rem 2.4rem;
	}
`;

export const LogoContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1.2rem;
`;

export const AvailablePlan = styled.div`
	display: flex;
	align-items: center;
	gap: 0.8rem;
`;

export const DeactivateButtonCss = css`
	background-color: var(--red) !important;
	border-color: var(--red) !important;
`;
